<div class="container" fxLayout="row" fxLayoutAlign="center none">
  <div fxFlex="95%" class="wrapper">
    <mat-card>
      <mat-card-content>
        <div class="filter-container" [formGroup]="formGroup">
          <div id="header-wrapper">
            <mat-form-field class="usage-filter">
              <mat-label>Applicable IN</mat-label>
              <mat-select formControlName="usage" multiple>
                <mat-option
                  *ngFor="let option of usageFilterOptions"
                  [value]="option.value"
                >
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button
              mat-raised-button
              color="primary"
              class="filter-button"
              (click)="applyFilter()"
            >
              {{ "Appointment.ApplyFilter" | translate }}
            </button>
            <button
              mat-raised-button
              color="primary"
              class="filter-button"
              (click)="clearFilter()"
            >
              {{ "Appointment.ClearFilter" | translate }}
            </button>
          </div>
        </div>

        <div
          class="search-panel"
          fxLayout="row"
          fxLayoutGap="10px"
          fxLayoutAlign="space-between center"
        >
          <app-search-box
            class="search-box"
            [value]="searchValue"
            (filterValueChange)="onFilterValueChange($event)"
          ></app-search-box>
          <button
            mat-raised-button
            color="primary"
            class="action-btn btn-add"
            (click)="add()"
          >
            {{ "Add" | translate }}
          </button>
        </div>

        <div class="table-wrapper">
          <table mat-table [dataSource]="dataSource" matSort class="table">
            <!-- name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let element">
                {{ element.name }}
              </td>
            </ng-container>
            <!-- coupon type Column -->
            <ng-container matColumnDef="couponType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
              <td mat-cell *matCellDef="let element">
                {{ couponType[element.couponType] }}
              </td>
            </ng-container>
            <!-- value Column -->
            <ng-container matColumnDef="value">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Value</th>
              <td mat-cell *matCellDef="let element">
                {{ element.value }}
              </td>
            </ng-container>
            <!-- maximum user Column -->
            <ng-container matColumnDef="maximumUsers">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Max Users
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.maximumUsers }}
              </td>
            </ng-container>

            <!-- used count Column -->
            <ng-container matColumnDef="usedCount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Used Count
              </th>
              <td mat-cell *matCellDef="let element">
                {{
                  (element.usedCount || element.usedCount === 0) &&
                  element.maximumUsers
                    ? element.usedCount
                    : element.maximumUsers && !element.usedCount
                    ? "-"
                    : ""
                }}
              </td>
            </ng-container>

            <!-- Usages -->

            <ng-container matColumnDef="applicableIN">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Applicable IN
              </th>
              <td mat-cell *matCellDef="let element">
                {{ getUsageNames(element.usage) }}
              </td>
            </ng-container>
            <!-- Max Discount Column -->
            <ng-container matColumnDef="maxDiscount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Max Discount
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.maxDiscount }}
              </td>
            </ng-container>
            <!-- description Column -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Description
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.description }}
              </td>
            </ng-container>
            <!-- CreatedBy Column -->
            <ng-container matColumnDef="creator">
              <th
                class="createdByWidth"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
              >
                Created By
              </th>
              <td mat-cell *matCellDef="let element">
                <div class="name-number-container">
                  <a
                    *ngIf="
                      element?.creator?.name &&
                      element?.creator?.type !== actorType.Admin
                    "
                    class="link"
                    routerLink="/patients/details"
                    [queryParams]="{
                      mode: 'details',
                      id: element?.creator?.id
                    }"
                    target="_blank"
                    >{{ element?.creator?.name || "-" }}</a
                  >
                  <p>
                    {{
                      element.creator.name && element.creator.type
                        ? getRole(element.creator.type)
                        : "-"
                    }}
                  </p>
                </div>
              </td>
            </ng-container>
            <!-- Expiry Column -->
            <ng-container matColumnDef="expiredAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiry</th>
              <td mat-cell *matCellDef="let element">
                <p>
                  {{
                    element.expiredAt
                      ? (element.expiredAt | date: "dd/MM/yyyy")
                      : "-"
                  }}
                </p>
              </td>
            </ng-container>
            <!-- Action Column -->
            <ng-container matColumnDef="action" stickyEnd>
              <th
                mat-header-cell
                *matHeaderCellDef
                class="table-action-separator-right"
              >
                {{ "Action" | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="table-action-separator-right"
              >
                <div class="actn-btn">
                  <div class="child-btn">
                    <button
                      matTooltip="Edit"
                      mat-icon-button
                      (click)="edit(element, element.id)"
                    >
                      <mat-icon class="edit-icon-sm" svgIcon="edit"></mat-icon>
                    </button>
                  </div>
                  <div class="child-btn">
                    <button
                      matTooltip="Delete"
                      mat-icon-button
                      (click)="delete(element.id)"
                    >
                      <mat-icon color="primary">delete</mat-icon>
                    </button>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        <mat-paginator
          #paginator
          [pageSizeOptions]="[10, 20, 50]"
          showFirstLastButtons
        ></mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
</div>
